import _ from 'lodash'
import { ConnectionType } from '@wix/thunderbolt-becky-types'
import { getMultipleRefCompsIdFromInflatedId, getUniqueId } from '@wix/thunderbolt-commons'
import type { ConnectionList as ConnectionListType } from '@wix/thunderbolt-becky-types'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { DataItemWithOverridesRefs } from '../../types'
import { getRefCompIds } from '../../../byRefUtils'
import { CONTROLLERS_IN_MASTERPAGE, SITE_NAMESPACE } from '../../../constants'

const getInflatedControllerDataQuery = (context: string, controllerCompId: string) =>
	`${getUniqueId(context, controllerCompId)}-dataQuery`

export const Connections = createConsumptionDataNode<ConnectionListType, null, DataItemWithOverridesRefs>({
	toViewItem: ({ id, value: { dataItemWithOverrides }, rawModel }) => {
		const overrideContext = getMultipleRefCompsIdFromInflatedId(id)
		const ancestorsRefIds = getRefCompIds(overrideContext)

		// concat overrides connection items: https://wix.slack.com/archives/C03JEFVDSJW/p1683729709802649?thread_ts=1683724973.230039&cid=C03JEFVDSJW
		const items = _(dataItemWithOverrides)
			.flatMap((override, ancestorIndex) => {
				if (!override) {
					return override
				}

				const { dependencies, ...connectionList } = override
				const { items: overrideItems } = connectionList as ConnectionListType

				if (ancestorIndex === 0) {
					return overrideItems
				}
				const context = ancestorsRefIds[ancestorIndex - 1]

				const controllersInMasterPage = _.get(rawModel, [SITE_NAMESPACE, CONTROLLERS_IN_MASTERPAGE])

				return _.map(overrideItems, (connection) => {
					if (connection?.type !== ConnectionType.ConnectionItem) {
						return connection
					}
					// inflate controllerId only if controller is not in master page
					const appControllerId = dependencies[_.get(connection, 'controllerId')!]
					const inflatedControllerId = getInflatedControllerDataQuery(context, appControllerId)

					const controllerId = controllersInMasterPage[appControllerId]
						? connection.controllerId
						: inflatedControllerId

					return {
						...connection,
						controllerId,
					}
				})
			})
			.compact()
			.value()

		return { id, type: 'ConnectionList', items }
	},
})
